import { Component, OnDestroy, OnInit } from '@angular/core'
import { Router, RouterLink } from '@angular/router'
import { TranslatePipe, TranslateService } from '@ngx-translate/core'
import { SvgIconComponent } from 'angular-svg-icon'
import { NzNotificationService } from 'ng-zorro-antd/notification'
import { Observable, Subscription, tap } from 'rxjs'

import { BackButtonComponent } from '../../components/back-button/back-button.component'
import { BranchDetailBaseAbstract } from '../../components/branch-detail-base/branch-detail-base.abstract'
import { BranchDetailBaseComponent } from '../../components/branch-detail-base/branch-detail-base.component'
import { ButtonComponent } from '../../components/button/button.component'
import { PageHeadlineComponent } from '../../components/page-headline/page-headline.component'
import { TypedTemplateDirective } from '../../directives/typed-template.directive'
import { Branch } from '../../models/branch.model'
import { BranchRepository } from '../../repositories/branch/branch.repository'

@Component({
  selector: 'app-upload-detail',
  standalone: true,
  imports: [
    ButtonComponent,
    SvgIconComponent,
    RouterLink,
    TranslatePipe,
    TypedTemplateDirective,
    PageHeadlineComponent,
    BranchDetailBaseComponent,
    BackButtonComponent,
  ],
  templateUrl: './upload-detail.component.html',
})
export class UploadDetailComponent
  extends BranchDetailBaseAbstract
  implements OnInit, OnDestroy
{
  private branchSubscription!: Subscription
  public branch?: Branch

  public constructor(
    private readonly branchRepository: BranchRepository,
    private readonly translateService: TranslateService,
    private readonly notificationService: NzNotificationService,
    private readonly router: Router
  ) {
    super()
  }

  public ngOnInit(): void {
    this.branchSubscription = this.fetchBranchDetails().subscribe()
  }

  public ngOnDestroy(): void {
    this.branchSubscription?.unsubscribe()
  }

  private fetchBranchDetails(): Observable<unknown> {
    return this.branchRepository.getById(this.id).pipe(
      tap((res) => {
        this.branch = {
          ...res.data.attributes,
          id: res.data.id,
        }
      })
    )
  }

  public onClearing(): void {
    this.isLoading = true
    this.branchRepository.clear(this.id).subscribe(() => {
      this.notificationService.success(
        this.translateService.instant(
          'pages.uploadDetail.clearing.notification.success.title'
        ),
        ''
      )
      this.router.navigate(['uploads'])
    })
  }
}
